import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import React from 'react';
function useScrollLock(targetElement, disableScroll, bodyScrollOption) {
    React.useLayoutEffect(() => {
        if (!targetElement) {
            return;
        }
        if (disableScroll) {
            disableBodyScroll(targetElement, bodyScrollOption);
        }
        else {
            enableBodyScroll(targetElement);
        }
        return () => {
            enableBodyScroll(targetElement);
        };
    }, [disableScroll, targetElement]);
}
export default useScrollLock;
